import { Checkbox, FormControlLabel, makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { Skeleton } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import Utils, { ONE_DAY_MS } from "../../helpers/Utils";


const useStyles = makeStyles((theme) => ({
  formLabel: { fontWeight: 600, color: "#181f48" },
  checkBoxStyle: { color: "#0E1B3D", fontSize: "16px", fontWeight: 600 },
  addDealButton: {
    color: "#fff",
    padding: "7px 12px",
    fontWeight: 600,
    borderRadius: "5px",
    textTransform: "capitalize",
    backgroundColor: "#316AFF",
    width: "120px",
    border: "none",
    cursor: "pointer",
    "&:hover": { backgroundColor: "#254edb" },
    "&:focus": { backgroundColor: "#254edb" },
  },
  dialogContent: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  iframeContainer: { position: "relative", width: "100%", height: 615 },
}));


const TrainingVideoModal = ({ open, onClose, videoSrc, moduleId }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [showModal, setShowModal] = useState(true);
  
  useEffect(() => {
    const hideKey = `hideTrainingModal_${moduleId}`;
    const cookieValue = Utils.getCookieForModalOpen(hideKey);
  
    if (cookieValue === "forever" || cookieValue === "temp") {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  }, [moduleId]);

  useEffect(() => {
    if (!loading) return;
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, [loading]);

  const handleIframeLoad = () => {
    setLoading(false);
  };
  const handleClose = () => {
    const hideKey = `hideTrainingModal_${moduleId}`;
  
    if (dontShowAgain) {
      Utils.setCookieForModalClose(hideKey, "forever", ONE_DAY_MS * 365); // Clearer intent
    } else {
      Utils.setCookieForModalClose(hideKey, "temp", ONE_DAY_MS); // Temporary hide
    }
    setShowModal(false);
    onClose();
  };
  

  return (
    <Dialog
      open={open && showModal}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      aria-labelledby="training-video-title"
      aria-describedby="training-video-description"
    >
      <div className={classes.dialogContent}>
        {loading ? (
          <Skeleton variant="rect" width="100%" height={615} style={{ borderRadius: 8 }} />
        ) : (
          <div className={classes.iframeContainer}>
            <iframe
              width="925"
              height="615"
              src={videoSrc || "https://cdn.pixabay.com/video/2020/06/22/42890-432450896_large.mp4"}
              title="Training Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              onLoad={handleIframeLoad}
            />
          </div>
        )}
        <div className={classes.actions}>
          <FormControlLabel
            control={
              <Checkbox
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
                color="primary"
              />
            }
            label="Don't show this again"
            classes={{ label: classes.checkBoxStyle }}
          />
          <button variant="contained" className={classes.addDealButton} onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default TrainingVideoModal;